var _circle, _circle2, _g, _g2, _rect, _rect2, _path, _path2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_319)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_319)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 95,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.6665 118C48.6665 119.105 47.7712 120 46.6665 120H33.3332C32.2285 120 31.3332 119.105 31.3332 118V104C33.3332 104 32.2285 104 33.3332 104H46.6665C47.7712 104 46.6665 104 48.6665 104V118Z",
    fill: "#006A53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6665 120H31.3332V115.333C32.6665 115.333 31.9305 115.333 32.6665 115.333H47.3332C48.0692 115.333 47.3332 115.333 48.6665 115.333V120Z",
    fill: "#3EA48E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 111.333C28.6667 111.333 28.2987 111.333 28.6667 111.333H30.6667C31.0347 111.333 30.25 111.333 31.3333 111.333V120H48.6667V111.333C49.3333 111.333 48.9653 111.333 49.3333 111.333H51.3333C51.7013 111.333 51.5 111.333 52 111.333V121.333C52 122.806 50.806 124 49.3333 124H30.6667C29.194 124 28 122.806 28 121.333V111.333Z",
    fill: "#008B6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 110,
    width: 30,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 118,
    width: 16,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 89C46.0751 89 51 84.0751 51 78H29C29 84.0751 33.9249 89 40 89Z",
    fill: "#E8F0FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 75,
    width: 22,
    height: 3,
    fill: "#176DE5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 76,
    width: 38,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 84,
    width: 16,
    height: 4,
    fill: "#ECEDEE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_319)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 96,
    height: 22,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 96,
    height: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 32,
    height: 4,
    fill: "#ECEDEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 36H43L46 48H34L37 36Z",
    fill: "#FFF6D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48H46L44 60H36L34 48Z",
    fill: "#FFD43E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 42,
    width: 34,
    height: 4,
    fill: "#ECEDEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 50,
    width: 24,
    height: 4,
    fill: "#ECEDEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_319",
    x: 5,
    y: 25,
    width: 110,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_319"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_319",
    x: 5,
    y: 3,
    width: 110,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_319"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_319",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.b01479125bcca6271ba8557269f30960.svg";
export { ForwardRef as ReactComponent };